import { useEffect, useRef, useState } from 'react';

/** Only visible locks animate; the parent book supplies lift, perspective and drag. */
export function EbookShelfLock({ shake }: { shake: number }) {
  const host = useRef<HTMLSpanElement>(null);
  const [moving, setMoving] = useState(false);
  useEffect(() => {
    const element = host.current;
    if (!element) return;
    let intersecting = false;
    const update = () => setMoving(intersecting && document.visibilityState === 'visible');
    const observer = new IntersectionObserver(([entry]) => {
      intersecting = entry?.isIntersecting ?? false;
      update();
    });
    observer.observe(element);
    document.addEventListener('visibilitychange', update);
    return () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', update);
    };
  }, []);
  return (
    <span
      ref={host}
      className={`ebook-shelf-lock${moving ? ' is-visible' : ''}`}
      aria-hidden="true"
    >
      <span className="ebook-shelf-lock__float">
        <img
          key={shake}
          className={shake ? 'is-shaking' : undefined}
          src="/assets/ebook-bookshelf/golden-lock-v1.webp"
          alt=""
          draggable={false}
          width="256"
          height="322"
        />
      </span>
    </span>
  );
}
